/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Slots_IntroInputs */

const en_slots_intro = /** @type {(inputs: Slots_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The rows of your week plan. Hidden slots don’t appear in the plan.`)
};

const de_slots_intro = /** @type {(inputs: Slots_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Zeilen deines Wochenplans. Ausgeblendete Mahlzeiten erscheinen nicht im Plan.`)
};

/**
* | output |
* | --- |
* | "The rows of your week plan. Hidden slots don’t appear in the plan." |
*
* @param {Slots_IntroInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const slots_intro = /** @type {((inputs?: Slots_IntroInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Slots_IntroInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_slots_intro(inputs)
	return en_slots_intro(inputs)
});